import React from 'react';
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import { isIPhone } from "@/modules/iOSDetection";
import { mouseOver, mouseLeave } from "@/modules/mouseInteractions";

import { assetImg } from "@/modules/moduleImporter";

import { IGameTableType } from "@/types/GlobalTypes";

import "./index.scss";
import nary from "@/modules/nary";

//Dice 6
export default class M8 extends React.PureComponent<IGameTableType> {
	state = {
		activeHover: ""
	};

	render() {
		const { langdata } = this.props;

		const win = this.props.win || "";

		const pcodeProp = { pcode: this.props.pcode };

		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		};

		const commonTooltipProps = {
			langStr: langdata.language_code
		};

		return (
			this.props.portrait ?
				<div className="sl-table m8-portrait">
					<div className="row">
						<div className={"sl-bet col-xs-6 sl-green-old" + ((+win <= 3 && win !== "") ? " sl-yellow-alternating" : "")}

							{...{
								bet: "Small",
								group: "n50",
								...pcodeProp
							}}

							onClick={this.props.insertBet}>

							{this.props.langdata["txt_small"]}
							<div className="bet-type">1:0.95</div>
							<Chips {...commonChipProps} betKey="Small+n50" />
						</div>
						<div className={"sl-bet col-xs-6 sl-green-old" + ((+win >= 4) ? " sl-yellow-alternating" : "")}

							{...{
								bet: "Big",
								group: "n50",
								...pcodeProp
							}}
							//bet="Big" pcode={this.props.pcode} group="n50"

							onClick={this.props.insertBet}>
							{this.props.langdata["txt_big"]}
							<div className="bet-type">1:0.95</div>
							<Chips {...commonChipProps} betKey="Big+n50" />
						</div>
					</div>

					<div className="row">
						<div className={"sl-bet col-xs-6 sl-green-old" + ((+win % 2) ? " sl-yellow-alternating" : "")}
							{...{
								bet: "Odd",
								group: "n50",
								...pcodeProp
							}}
							// bet="Odd" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet}>
							{this.props.langdata["txt_odd"]}
							<div className="bet-type">1:0.95</div>
							<Chips {...commonChipProps} betKey="Odd+n50" />
						</div>
						<div className={"sl-bet col-xs-6 sl-green-old" + (!(+win % 2) && win !== "" ? " sl-yellow-alternating" : "")}

							{...{
								bet: "Even",
								group: "n50",
								...pcodeProp
							}}
							// bet="Even" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet}>
							{this.props.langdata["txt_even"]}
							<div className="bet-type">1:0.95</div>
							<Chips {...commonChipProps} betKey="Even+n50" />
						</div>
					</div>

					<div className="row">
						{
							nary(6).map(num =>
								<div className={"sl-bet col-xs-4 m8-taller sl-green-old" + (Number(win) === num ? " sl-yellow-alternating" : "")}
									key={"m8_portrait_n_" + num}
									{...{
										bet: num,
										group: "n",
										...pcodeProp
									}}
									// bet={num} pcode={this.props.pcode} group="n"
									onClick={this.props.insertBet}>
									{assetImg("m8", num + "")}
									<div className="bet-type">1:4.5</div>
									<Chips {...commonChipProps} betKey={num + "+n"} />
								</div>
							)
						}
					</div>


					{
						[
							["1,4", "2,5", "3,6"]
						].map((row, rowIdx) =>
							row.map((groupComma, groupIdx) => {
								const firstPercent = 4;
								const leftSpace = 33;

								return <div className={"sl-bet hidden col-xs-3"}
										key={"m8_portrait_n2_" + groupIdx}
										style={{
											position: "absolute",
											left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "%)",
											top: "calc(61% + " + (rowIdx * 12) + "vh)",
											// background: "rgba(0,0,0,0.5)",
											background: "transparent",
											border: "none",
											height: "4vh"
										}}>
									<Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
									<div className="sl-hover-hidden"

										{...{
											bet: groupComma,
											pcode: this.props.pcode,
											group: "n2"
										}}

										onClick={this.props.insertBet}
										onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined}
										onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}>
									</div>
								</div>;
							})
						)
					}

					{
						[
							["1,2", "2,3"],
							["4,5", "5,6"]
						].map((row, rowIdx) =>
							row.map((groupComma, groupIdx) => {
								const firstPercent = 29;
								const leftSpace = 33;

								return <div className={"sl-bet hidden col-xs-1"}
										key={"m8_portrait_n2_2_" + groupIdx}
										style={{
											position: "absolute",
											left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "%)",
											top: "calc(37% + " + (rowIdx * 12) + "vh)",
											// background: "rgba(255,255,0,0.5)",
											background: "transparent",
											border: "none",
											height: "9vh"
										}}>
									<Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
									<div className="sl-hover-hidden"

										{...{
											bet: groupComma,
											pcode: this.props.pcode,
											group: "n2"
										}}

										onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
								</div>;
							})
						)
					}

					{
						[
							["1,2,4,5", "2,3,5,6"]
						].map((row, rowIdx) =>
							row.map((groupComma, groupIdx) => {
								const firstPercent = 29;
								const leftSpace = 33;

								return <div className={"sl-bet hidden col-xs-1"}
									key={"m8_portrait_n4_" + groupIdx}
									style={{
										position: "absolute",
										left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "%)",
										top: "calc(61% + " + (rowIdx * 12) + "vh)",
										// background: "rgba(0,128,0,0.5)",
										background: "transparent",
										border: "none",
										height: "4vh"
									}}>
									<Chips between={true} {...commonChipProps} betKey={groupComma + "+n4"} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n4"]} />
									<div className="sl-hover-hidden"

										{...{
											bet: groupComma,
											group: "n4",
											...pcodeProp
										}}
										//bet={groupComma} pcode={this.props.pcode} group="n4"

										onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
								</div>;
							})
						)
					}
				</div>


				: <div className="sl-table">
					<div className="m8-table">
						<div className="sides">
							<div className={"sl-bet m8-sl-table-cell sl-green-old sl-box-12" + (+win <= 3 && win !== "" ? " sl-yellow-alternating" : "")}>
								<div>{this.props.langdata["txt_small"]}</div>
								{/* <div>SMALL</div> */}
								<div className="bet-type">1:0.95</div>
								<Chips {...commonChipProps} betKey="Small+n50" />
								<Tooltip {...commonTooltipProps} bet={this.props.bets["Small+n50"]} />
								<div className="sl-hover-hidden"

									{...{
										bet: "Small",
										group: "n50",
										...pcodeProp
									}}
									// bet="Small" pcode={this.props.pcode} group="n50"

									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>
							<div className={"sl-bet m8-sl-table-cell sl-green-old sl-box-12" + (+win % 2 ? " sl-yellow-alternating" : "")}>
								<div>{this.props.langdata["txt_odd"]}</div>
								{/* <div>ODD</div> */}
								<div className="bet-type">1:0.95</div>
								<Chips {...commonChipProps} betKey="Odd+n50" />
								<Tooltip {...commonTooltipProps} bet={this.props.bets["Odd+n50"]} />
								<div className="sl-hover-hidden"

									{...{
										bet: "Odd",
										group: "n50",
										...pcodeProp
									}}
									// bet="Odd" pcode={this.props.pcode} group="n50"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>
						</div>
						<div className="mainbox">
							{
								nary(6).map((item, idx) => {
									let styles = "";
									const activeHover = this.state.activeHover;
									if (
										(activeHover.indexOf(item + "") >= 0) ||
										(activeHover === "Odd" && ((idx + 1) % 2)) ||
										(activeHover === "Even" && !((idx + 1) % 2)) ||
										(activeHover === "Small" && idx < 3) ||
										(activeHover === "Big" && idx >= 3))
										styles += " sl-bet-hover";

									return (
										<div key={`m8_g_mainbox_${idx}`} className={"sl-bet m8-sl-table-cell sl-green-old sl-box-4" + styles + (win === (idx + 1) + "" ? " sl-yellow-alternating" : "")}

											{...{
												bet: idx + 1,
												group: "n",
												...pcodeProp
											}}
											// bet={idx + 1} pcode={this.props.pcode} group="n"
											onClick={this.props.insertBet}>

											{assetImg("m8", item + "")}
											<div className="bet-type">1:4.5</div>
											<Chips {...commonChipProps} betKey={(idx + 1) + "+n"} />
											<Tooltip {...commonTooltipProps} bet={this.props.bets[(idx + 1) + "+n"]} />
										</div>
									);
								})
							}
						</div>
						<div className="sides">
							<div className={"sl-bet m8-sl-table-cell sl-green-old sl-box-12" + (+win >= 4 ? " sl-yellow-alternating" : "")}>
								<div>{this.props.langdata["txt_big"]}</div>
								{/* <div>BIG</div> */}
								<div className="bet-type">1:0.95</div>
								<Chips {...commonChipProps} betKey="Big+n50" />
								<Tooltip {...commonTooltipProps} bet={this.props.bets["Big+n50"]} />
								<div className="sl-hover-hidden"

									{...{
										bet: "Big",
										group: "n50",
										...pcodeProp
									}}
									// bet="Big" pcode={this.props.pcode} group="n50"

									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>
							<div className={"sl-bet m8-sl-table-cell sl-green-old sl-box-12" + (!(+win % 2) && win !== "" ? " sl-yellow-alternating" : "")}>
								<div>{this.props.langdata["txt_even"]}</div>
								{/* <div>EVEN</div> */}
								<div className="bet-type">1:0.95</div>
								<Chips {...commonChipProps} betKey="Even+n50" />
								<Tooltip {...commonTooltipProps} bet={this.props.bets["Even+n50"]} />
								<div className="sl-hover-hidden"

									{...{
										bet: "Even",
										group: "n50",
										...pcodeProp
									}}
									// bet="Even" pcode={this.props.pcode} group="n50"

									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>
						</div>
					</div>

					{/*Multibet starts here*/}
					{
						[
							["1,2", "2,3"],
							["4,5", "5,6"]
						].map((row, rowIdx) =>
							row.map((groupComma, groupIdx) => {
								const firstPercent = this.props.maximised ? 39 : 36;
								const leftSpace = this.props.maximised ? 231 : 70;
								const width = this.props.maximised ? "32px" : "25px";

								return <div key={"m8_multibet_1_" + rowIdx + "_" + groupIdx}
									className={"sl-bet hidden sl-green-old"}
									style={{
										position: "absolute",
										left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
										top: "calc(8% + " + (rowIdx * 100) + "px)",
										background: "transparent",
										width: width,
										height: "70px"
									}}>
									<Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
									<div className="sl-hover-hidden"

										{...{
											bet: groupComma,
											group: "n2",
											...pcodeProp
										}}
										// bet={groupComma} pcode={this.props.pcode} group="n2"
										onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
								</div>;
							})
						)
					}

					{
						[
							["1,4", "2,5", "3,6"]
						].map((row, rowIdx) =>
							row.map((groupComma, groupIdx) => {
								const firstPercent = this.props.maximised ? 22 : 22.5;
								const leftSpace = this.props.maximised ? 231 : 70;
								const width = this.props.maximised ? "200px" : "60px";

								return <div key={"m8_multibet_2_" + rowIdx + "_" + groupIdx}
									className={"sl-bet hidden sl-green-old"}
									style={{
										position: "absolute",
										left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
										top: "calc(42% + " + (rowIdx * 100) + "px)",
										background: "transparent",
										width: width,
										height: "28px"
									}}>
									<Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
									<div className="sl-hover-hidden"

										{...{
											bet: groupComma,
											group: "n2",
											...pcodeProp
										}}
										//bet={groupComma} pcode={this.props.pcode} group="n2"

										onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
								</div>;
							})
						)
					}

					{
						[
							["1,2,4,5", "2,3,5,6"]
						].map((row, rowIdx) =>
							row.map((groupComma, groupIdx) => {
								const firstPercent = this.props.maximised ? 39 : 36;
								const leftSpace = this.props.maximised ? 231 : 70;
								const width = this.props.maximised ? "28px" : "25px";

								return <div key={"m8_multibet_2_" + rowIdx + "_" + groupIdx}
									className={"sl-bet hidden sl-green-old"}
									style={{
										position: "absolute",
										left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
										top: "calc(42% + " + (rowIdx * 100) + "px)",
										background: "transparent",
										width: width,
										height: "28px"
									}}>
									<Chips between={true} {...commonChipProps} betKey={groupComma + "+n4"} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n4"]} />
									<div className="sl-hover-hidden"

										{...{
											bet: groupComma,
											group: "n4",
											...pcodeProp
										}}
										// bet={groupComma} pcode={this.props.pcode} group="n4"

										onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
								</div>;
							})
						)
					}
				</div>
		);
	}
}
